<template>
	<div class="userinfo" ref="height_top" v-bind:style="{ height: tableHeight + 'px' }" style="overflow: auto;">
		<div style="">
			<el-row>
				<!-- <el-col :span="3" :offset="2">
					<div class="img">
						
					</div>
				</el-col> -->
				<el-col :span="24" style="background-color:#f2f2f2">
					<div class="content">
						<el-row>
							<!-- <el-col :span="6">
								<el-row>
									<el-col :span="2" style="display: flex;align-items: center;">
										<img src="../../assets/img/user_def_pic.png" alt="">
									</el-col>
									<el-col :span="21" class="content_border">
										<div class="name">{{username}}，欢迎您！</div>
									</el-col>
								</el-row>
							</el-col> -->
							<el-col :xs="24" :sm="12" :md="7" :lg="5" :xl="4">
								<el-row>
									<el-col :span="2" style="display: flex;align-items: center;">
										<img src="../../assets/img/no_icon.png" alt="">
									</el-col>
									<el-col :span="10">
										<div class="title">用户编号：</div>
									</el-col>
									<el-col :span="9" class="content_border">
										{{code}}
									</el-col>
								</el-row>
							</el-col>
							<el-col :xs="24" :sm="12" :md="7" :lg="5" :xl="4" style="background-color:#f2f2f2">
								<el-row>
									<el-col :span="2" style="display: flex;align-items: center;">
										<img src="../../assets/img/mobile_icon.png" alt="">
									</el-col>
									<el-col :span="10">
										<div class="title">账号绑定：</div>
									</el-col>
									<el-col :span="9" class="content_border">
										{{mobile}}
									</el-col>
								</el-row>
							</el-col>
							<el-col :xs="24" :sm="12" :md="7" :lg="5" :xl="4" style="background-color:#f2f2f2">
								<el-row  class="user_radio">
									<el-col :span="10" style="">
										<el-radio v-model="form.radio" label="1">个人用户</el-radio>
									</el-col>
									<el-col :span="11" class="content_border">
										<el-radio v-model="form.radio" label="2">企业用户</el-radio>
									</el-col>
								</el-row>
							</el-col>
							<!-- <el-col :span="6">
								<el-row>
									<el-col :span="2" style="display: flex;align-items: center;">
										<img src="../../assets/img/comp_icon.png" alt="">
									</el-col>
									<el-col :span="10">
										<div class="title">用户类型：</div>
									</el-col>
									<el-col :span="12">
										<el-button type="danger" size="small">个人用户</el-button>
									</el-col>
								</el-row>
							</el-col> -->
						</el-row>
					</div>
				</el-col>
			</el-row>
			<!-- <el-row>
				<el-col :xs="6" :sm="6" :md="5" :lg="4" :xl="3">
					
				</el-col>
				<el-col :xs="6" :sm="6" :md="5" :lg="4" :xl="3">
					
				</el-col>
			</el-row> -->
		</div>
		<div class="form">
			<el-row>
				<el-col :span="24" v-if="form.radio==1">
					<el-form :model="form" ref="formData" :rules="rules1" label-width="auto">
						<el-row>
							<el-col :xs="23" :sm="23" :md="10" :lg="10" :xl="10" :offset="1">
								<el-col :span="24">
									<el-form-item label="手机号：" >
										<el-input v-model="form.mobile" disabled />
									</el-form-item>
								</el-col>
								<el-col :span="24">
									<el-form-item label="联系人："  prop="linkman">
										<el-input v-model="form.linkman"  />
									</el-form-item>
								</el-col>
								<!-- <el-col :span="24">
									<el-form-item label="昵称："  prop="username">
										<el-input v-model="form.username"  />
									</el-form-item>
								</el-col> -->
								<el-col :span="24">
									<el-row>
										<el-col :span="12">
											<el-form-item label="省份："  prop="province_id">
												<el-select v-model="form.province_id" placeholder="请选择省份" @change="changeProvices">
													<el-option :label="item.name" v-for="(item,key) in provices" :value="item.id"></el-option>
												</el-select>
											</el-form-item>
										</el-col>
										<el-col :span="12">
											<el-form-item label="城市："  prop="city_id">
												<el-select v-model="form.city_id" placeholder="请输入城市" @change="changeCity">
													<el-option :label="item.name" v-for="(item,key) in city" :value="item.id"></el-option>
												</el-select>
											</el-form-item>
										</el-col>
									</el-row>
								</el-col>
								<el-col :span="24">
									<el-form-item label="公司地址："  prop="company_address">

										<el-input v-model="form.company_address" placeholder="请输入公司地址" >
											<template #prepend>{{form.province_city}}</template>
										</el-input>
									</el-form-item>
								</el-col>
							</el-col>
							<el-col :xs="23" :sm="23" :md="10" :lg="10" :xl="10" :offset="1">
								<el-col :span="24">
										<el-form-item label="收货人：" prop="legal_person">
											<el-input v-model="form.legal_person" placeholder="请输入收货人" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="收货地址：" prop="address">
											<el-input v-model="form.address" placeholder="请输入收货地址" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="收货电话：" prop="tel">
											<el-input v-model="form.tel" placeholder="请输入收货电话" />
										</el-form-item>
									</el-col>
							</el-col>
						</el-row>
					</el-form>
				</el-col>
				<el-col :span="24" v-else-if="form.radio==2">
					<el-form :model="form" ref="formData" :rules="rules2" label-width="auto">
						<el-row>
							<el-col :xs="23" :sm="23" :md="10" :lg="10" :xl="10" :offset="1">
								<el-row>
									<el-col :span="24" v-if="form.tag==1">
										<el-form-item label=" ">
											<el-alert title="提交成功，请等待审核通过" type="warning" />
										</el-form-item>
									</el-col>
									<el-col :span="24" v-if="form.tag==2">
										<el-form-item label=" ">
											<el-alert title="审核通过，您现在已是企业用户" type="success" />
										</el-form-item>
									</el-col>
									<el-col :span="24" v-if="form.tag==3">
										<el-form-item label=" ">
											<el-alert :title="'审核被拒绝，理由：'+form.tag_reason" type="error" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="手机号：">
											<el-input v-model="form.mobile" disabled />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="企业名称：" prop="company">
											<el-input v-model="form.company" placeholder="请输入企业名称" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="开票地址：" prop="bills_addr">
											<el-input v-model="form.bills_addr" placeholder="请输入开票地址" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="开户银行：" prop="bankname">
											<el-input v-model="form.bankname" placeholder="请输入开户银行" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="行号：">
											<el-input v-model="form.fax" placeholder="请输入行号" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="账号：" prop="bankaccount">
											<el-input v-model="form.bankaccount" placeholder="请输入账号" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="税号：" prop="tax_code">
											<el-input v-model="form.tax_code" placeholder="请输入税号" />
										</el-form-item>
									</el-col>
									
									<el-col :span="24">
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="12">
										<el-form-item label="营业执照：" prop="img_business_name">
											<el-input v-model="form.img_business_name" disabled placeholder="">
												<template #append>
													<el-button color="#ff8a5c" style="color:#fff" @click="upload('upload_business')">上传图片</el-button>
												</template>
											</el-input>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="企业认证函：" prop="img_qualily_name">
											<el-input v-model="form.img_qualily_name" disabled placeholder="">
												<template #append>
													<el-button color="#ff8a5c" style="color:#fff" @click="upload('upload_qualily')">上传图片</el-button>
												</template>
											</el-input>
										</el-form-item>
									</el-col>
								</el-row>
							</el-col>
							<el-col :xs="23" :sm="23" :md="10" :lg="10" :xl="10" :offset="1">
								<el-col :span="24">
										<el-form-item label="收货人：" prop="legal_person">
											<el-input v-model="form.legal_person" placeholder="请输入收货人" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="收货地址：" prop="address">
											<el-input v-model="form.address" placeholder="请输入收货地址" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="收货电话：" prop="tel">
											<el-input v-model="form.tel" placeholder="请输入收货电话" />
										</el-form-item>
									</el-col>
							</el-col>
						</el-row>
					</el-form>
				</el-col>
			</el-row>
			<el-row class="bottom">
				<el-col :xs="23" :sm="23" :md="10" :lg="10" :xl="10" :offset="1" style="text-align: right;">
					<el-link type="primary" style="margin-right:15px" @click="cert_addr" v-if="form.radio==2">企业认证函下载</el-link>
					<el-button color="#ff8a5c" style="color:#fff" @click="saveuser" :loading='loading' v-if="form.radio==1">保存</el-button>
					<el-button color="#ff8a5c" style="color:#fff" @click="add" :loading='loading' v-if="form.radio==2">保存</el-button>
					<el-button color="#ff8a5c" style="color:#fff" @click="applytag" :loading='loading' v-if="form.radio==2">提交</el-button>
				</el-col>
			</el-row>
		</div>
		<el-upload class="upload-demo" ref="upload_business" action="#" :file-list="fileList_business" :http-request="handleRequest_business" name="upload_business">
		</el-upload>
		<el-upload class="upload-demo" ref="upload_qualily" action="#" :file-list="fileList_qualily" :http-request="handleRequest_qualily" name="upload_qualily">
		</el-upload>
	</div>
</template>
<script>
import { ElMessage,ElMessageBox } from 'element-plus'
export default {
	components: {},
	data() {

		return {
			provices: [],
			city: [],
			tableHeight: '',
			fileList_business: [],
			fileList_qualily: [],
			loading: false,
			form: {
				name: '',
				radio: '1',
			},
			user_id: '',
			username: '',
			mobile: '',
			code: '',
			rules1: { //
				username: [{
					required: true,
					message: '请填写昵称',
					trigger: 'blur'
				}],
				legal_person: [{
					required: true,
					message: '请填写收货人',
					trigger: 'blur'
				}],
				address: [{
					required: true,
					message: '请填写收货地址',
					trigger: 'blur'
				}],
				tel: [{
					required: true,
					message: '请填写收货电话',
					trigger: 'blur'
				}],
				linkman: [{
					required: true,
					message: '请填写联系人',
					trigger: 'blur'
				}],
				province_id: [{
					required: true,
					message: '请选择省份',
					trigger: 'change'
				}],
				city_id: [{
					required: true,
					message: '请选择城市',
					trigger: 'blur'
				}],
				company_address: [{
					required: true,
					message: '请填写公司地址',
					trigger: 'blur'
				}],
			},
			rules2: { //
				company: [{
					required: true,
					message: '请填写企业名称',
					trigger: 'blur'
				}],
				bills_addr: [{
					required: true,
					message: '请填写开票地址',
					trigger: 'blur'
				}],
				bankname: [{
					required: true,
					message: '请填写开户银行',
					trigger: 'blur'
				}],
				fax: [{
					required: true,
					message: '请填写行号',
					trigger: 'blur'
				}],
				bankaccount: [{
					required: true,
					message: '请填写账号',
					trigger: 'blur'
				}],
				tax_code: [{
					required: true,
					message: '请填写税号',
					trigger: 'blur'
				}],
				legal_person: [{
					required: true,
					message: '请填写收货人',
					trigger: 'blur'
				}],
				address: [{
					required: true,
					message: '请填写收货地址',
					trigger: 'blur'
				}],
				tel: [{
					required: true,
					message: '请填写收货电话',
					trigger: 'blur'
				}],
				img_business_name: [{
					required: true,
					message: '请选择营业执照',
					trigger: 'blur'
				}],
				img_qualily_name: [{
					required: true,
					message: '请选择企业认证函',
					trigger: 'blur'
				}],
			},
			userinfo: {},
		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {
		this.getProvices();
		this.getusermsg();
		this.tableHeight_fun();

	},
	watch: {

	},
	methods: {
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 55
			})
		},
		changeProvices() {
			this.set_province_city();
			this.form.city_id = ""
			this.getcitys();
		},
		changeCity() {
			this.set_province_city();
		},
		cert_addr(){
			if (this.form.cert_addr) {
				window.open(this.$axios.defaults.baseURL+'/yunsys/downloads?name='+this.form.cert_addr, '_blank');
			}else{
				return ElMessage({
					message: '请先保存数据，再下载企业认证函！',
					type: 'error',
					grouping: true // 开启合并功能

				})
			}
		},
		set_province_city(){
			this.province_city='';
			var obj=this;
			var name='';
			this.provices.forEach(function(item){
				if (item.id==obj.form.province_id) {
					name=item.name
				}
			})
			this.city.forEach(function(item){
				if (item.id==obj.form.city_id) {
					name=name+item.name
				}
			})
			this.form.province_city=name;
		},
		async getcitys() {
			await this.$axios.post('/api/yunsys.Website/getcitys', { id: this.form.province_id }).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						this.city = []
					} else {
						this.city = res.data;
						this.set_province_city();
					}

				})
				.catch(err => {
					this.city = []
				})
		},
		async getProvices() {
			await this.$axios.post('/api/yunsys.Website/getProvices').then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						this.provices = []
					} else {
						this.provices = res.data;
						this.set_province_city();
					}

				})
				.catch(err => {
					this.provices = []
				})
		},
		async getusermsg() {
			await this.$axios.post('/api/yunsys.Website/getusermsg').then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {

					} else {



						this.user_id = res.data.id;
						this.form.linkman = res.data.linkman;
						this.form.province_id = res.data.province_id;
						this.form.city_id = res.data.city_id;
						this.form.company_address = res.data.company_address;
						this.getcitys();



						this.username = res.data.username;
						this.mobile = res.data.mobile;
						this.code = res.data.code;
						this.form.username = res.data.username;
						this.form.mobile = res.data.mobile;

						this.form.company = res.data.company;
						this.form.bills_addr = res.data.bills_addr;
						this.form.bankname = res.data.bankname;
						this.form.fax = res.data.fax;
						this.form.bankaccount = res.data.bankaccount;
						this.form.tax_code = res.data.tax_code;
						this.form.legal_person = res.data.legal_person;
						this.form.username = res.data.username;
						this.form.address = res.data.address;
						this.form.tel = res.data.tel;
						this.form.img_business_name = res.data.img_business_name;
						this.form.img_qualily_name = res.data.img_qualily_name;
						this.form.tag = res.data.tag;
						this.form.tag_reason = res.data.tag_reason;
						this.form.cert_addr = res.data.cert_addr;
						/*if (this.form.tag) {
							this.form.radio = '2'
						}*/
					}

				})
				.catch(err => {
					/*return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})*/
				})
		},
		async handleRequest_business(file) {
			this.fileList_business = [file.file];

			this.form.img_business_name = file.file.name
		},
		async handleRequest_qualily(file) {
			this.fileList_qualily = [file.file];

			this.form.img_qualily_name = file.file.name
		},
		upload(name) {
			this.$refs[name].$el.querySelector('input[type="file"]').click();
			//this.$refs['upload_business'].$children[0].$refs.input.click();
		},
		async saveuser() {
			var obj = this;

			this.$refs.formData.validate(async v => {
				if (v) {
					this.loading = true
					await this.$axios.post('/api/yunsys.Website/saveuser', this.form).then(async (res) => {
							var res = res.data;
							this.loading = false
							if (res.code !== 0) {
								return ElMessage({
									message: res.msg,
									type: 'error',
									grouping: true // 开启合并功能
								})
							}
							this.getusermsg();
							return ElMessage({
								message: res.msg,
								type: 'success',
								grouping: true // 开启合并功能
							})

						})
						.catch(err => {
							this.loading = false
							return ElMessage({
								message: '系统错误',
								type: 'error',
								grouping: true // 开启合并功能

							})
						})
				} else {
					return this.$message.error('请填写必填项')
				}
			})

		},
		async applytag() {
			var obj = this;

			this.$refs.formData.validate(async v => {
				if (v) {
					this.loading = true
					await this.$axios.post('/api/yunsys.Website/applytag', this.form).then(async (res) => {
							var res = res.data;
							this.loading = false
							if (res.code !== 0) {
								return ElMessage({
									message: res.msg,
									type: 'error',
									grouping: true // 开启合并功能
								})
							}
							this.getusermsg();
							return ElMessage({
								message: res.msg,
								type: 'success',
								grouping: true // 开启合并功能
							})

						})
						.catch(err => {
							this.loading = false
							return ElMessage({
								message: '系统错误',
								type: 'error',
								grouping: true // 开启合并功能

							})
						})
				} else {
					return this.$message.error('请填写必填项')
				}
			})

		},
		add(){
			if (this.form.tag==2) {
				return ElMessage({
					message: '您已通过审核！',
					type: 'error',
					grouping: true // 开启合并功能

				})
				/*ElMessageBox.confirm(
					'您已通过审核，若保存数据，需要重新提交审核！',
					'提示', {
						confirmButtonText: '确认',
						cancelButtonText: '取消',
						type: 'warning',
					}
				)
				.then(() => {
					this.add_ajax()
				})
				.catch(() => {

				})*/
			}else{
				this.add_ajax()
			}
		},
		async add_ajax() {
			var obj = this;
			var seen = [];
			var replacer = function(key, value) {
				if (typeof value === "object" && value !== null) {
					if (seen.indexOf(value) >= 0) {
						return;
					}
					seen.push(value);
				}
				return value;
			};
			var parameter = new FormData()
			var formList = this.form;
			parameter.append('form', JSON.stringify(formList, replacer))
			let config = {
				headers: { 'Content-Type': 'multipart/form-data' }
			}
			if (this.fileList_business.length) {
				parameter.append('img_business', this.fileList_business[0])
			}
			if (this.fileList_qualily) {
				parameter.append('img_qualily', this.fileList_qualily[0])
			}
			this.loading = true
					await this.$axios.post('/api/yunsys.Website/applyuser', parameter, config).then(async (res) => {
							var res = res.data;
							this.loading = false
							if (res.code !== 0) {
								return ElMessage({
									message: res.msg,
									type: 'error',
									grouping: true // 开启合并功能
								})
							}
							this.getusermsg();
							return ElMessage({
								message: res.msg,
								type: 'success',
								grouping: true // 开启合并功能
							})

						})
						.catch(err => {
							this.loading = false
							return ElMessage({
								message: '系统错误',
								type: 'error',
								grouping: true // 开启合并功能

							})
						})
			/*this.$refs.formData.validate(async v => {
				if (v) {
					
				} else {
					return this.$message.error('请填写必填项')
				}
			})*/

		},
	}
}
</script>
<style lang="less" scoped>
.upload-demo {
	display: none
}
</style>